// extracted by css-extract-rspack-plugin
export default {"skeleton":"LazyCounter-module__skeleton__e2Qcl","counterLabel":"LazyCounter-module__counterLabel__YdixM"};